import { render, staticRenderFns } from "./activitySection.vue?vue&type=template&id=709732a2&scoped=true&"
import script from "./activitySection.vue?vue&type=script&lang=js&"
export * from "./activitySection.vue?vue&type=script&lang=js&"
import style0 from "./activitySection.vue?vue&type=style&index=0&id=709732a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709732a2",
  null
  
)

export default component.exports